<p-dialog
  header="Reject menu item"
  [closable]="!submitting()"
  [modal]="true"
  [style]="{ width: '36rem' }"
  [visible]="visible()"
  (visibleChange)="onVisibleChange($event)"
>
  <p class="confirm-text">
    Reject
    <strong>{{ entreeName() }}</strong>
    ?
  </p>

  <div class="form-fields">
    <div class="field">
      <label class="field-label" for="rejectReasonCode">Reason</label>
      <p-select
        appendTo="body"
        inputId="rejectReasonCode"
        optionLabel="label"
        optionValue="code"
        placeholder="Select a reason"
        [disabled]="loadingReasons() || submitting()"
        [ngModel]="rejectForm.reasonCode().value()"
        [options]="reasons()"
        (ngModelChange)="rejectForm.reasonCode().controlValue.set($event)"
      ></p-select>
      @if (selectedReason(); as reason) {
        <small class="field-hint">{{ reason.helpText }}</small>
      }
    </div>

    <div class="field">
      <label class="field-label" for="rejectReasonDetail">
        Detail
        @if (isOtherSelected()) {
          <span class="required-indicator">*</span>
        }
      </label>
      <textarea
        pTextarea
        id="rejectReasonDetail"
        rows="4"
        [disabled]="submitting()"
        [ngModel]="rejectForm.reasonDetail().value()"
        [placeholder]="isOtherSelected() ? 'Please describe the reason' : 'Optional additional context'"
        (ngModelChange)="rejectForm.reasonDetail().controlValue.set($event)"
      ></textarea>
      @if (isOtherSelected() && rejectForm.reasonDetail().touched() && !rejectForm.reasonDetail().valid()) {
        <small class="field-error">Please describe the reason.</small>
      }
    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button
      label="Cancel"
      severity="secondary"
      [disabled]="submitting()"
      [text]="true"
      (onClick)="onCancel()"
    ></p-button>
    <p-button
      icon="pi pi-times"
      label="Reject"
      severity="danger"
      [disabled]="!rejectForm().valid() || submitting()"
      [loading]="submitting()"
      (onClick)="submit()"
    ></p-button>
  </ng-template>
</p-dialog>
